import { useContext } from "react";
import CartOrderContext from "../context/CartOrderContext";

const useCartOrderContext = () => {
    const cartOrderContext = useContext(CartOrderContext);
    if (!cartOrderContext) {
        throw new Error('CartOrderContext has to be used within <CartOrderContext.Provider>');
    } else {
        return cartOrderContext
    }
}

export default useCartOrderContext;